class ListNotificationsData {

    constructor () {

        this._totalNotificationsUnread = 0;
        this._notificationsList = [];
        this._allNotifications = [];

    }

    getTotalNotificationsUnread() {
        return this._totalNotificationsUnread;
    }

    getNotificationsList() {
        return this._notificationsList;
    }

    setNotificationsList(notificationsList) {
        this._notificationsList = notificationsList;
        this._allNotifications = notificationsList;
    }

    setTotalNotificationsUnread(totalUnread) {
        this._totalNotificationsUnread = totalUnread;
    }

    toggleShowOnlyUnread(readValue) {
        const notifications = !readValue 
            ? this._allNotifications.filter(notification => notification.read === false)
            : this._allNotifications
        this._notificationsList = notifications;
    }

    markNotificationAsRead(notificationId) {
        this._notificationsList.forEach(notification => {
            if (notification.id === notificationId) {
                notification.read = true
            }
        });
        this._allNotifications.forEach(notification => {
            if (notification.id === notificationId) {
                notification.read = true
            }
        });
    }

}